export const DataRetentionSection = () => (
  <section>
    <h2>4. Data Retention</h2>

    <p>
      We retain Customer Data strictly on our customer's behalf, in accordance
      with their reasonable instructions and as further stipulated in our Data
      Processing Addendum and other commercial agreements with such customer.
    </p>

    <p>
      We retain Volca User Data and Volca Website, CRM & Prospect Data for as
      long as it is reasonably necessary in order to maintain and expand our
      relationship and provide you with our Services and offerings; in order to
      comply with our legal and contractual obligations; or to protect ourselves
      from any potential disputes (i.e. as required by laws applicable to
      log-keeping, records and bookkeeping, and in order to have proof and
      evidence concerning our relationship, should any legal issues arise
      following your discontinuance of use), all in accordance with our data
      retention policy.
    </p>

    <p>
      Please note that except as required by applicable law or our specific
      agreements with you, we will not be obligated to retain your Personal Data
      for any particular period, and we are free to securely delete it or
      restrict access to it for any reason and at any time, with or without
      notice to you. If you have any questions about our data retention policy,
      please contact us by e-mail at{" "}
      <a href="mailto:support@volca.ai">support@volca.ai</a>.
    </p>
  </section>
);
